<template>
  <div class="container">
    <h1>操作员申请</h1>
    <el-table :data="operators">
      <el-table-column prop="company_name" label="公司名称"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="phone" label="电话"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="primary" @click="confirmApprove(scope.row.user_id)">同意</el-button>
          <el-button type="danger" @click="confirmReject(scope.row.user_id)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      operators: []
    };
  },
  mounted() {
    this.fetchOperators();
  },
  methods: {
    async fetchOperators() {
      try {
        const response = await axios.get('/api/users/apply_operators');
        this.operators = response.data.operator_requests;
      } catch (error) {
        console.error('Error fetching operators:', error);
      }
    },
    confirmApprove(id) {
      this.$confirm('确定同意此申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.applyOperator(id, true);
      });
    },
    confirmReject(id) {
      this.$confirm('确定拒绝此申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.applyOperator(id, false);
      });
    },
    async applyOperator(id, apply) {
      try {
        await axios.put(`/api/users/${id}/apply_operator`, { apply });
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.fetchOperators();
      } catch (error) {
        console.error('Error applying operator:', error);
      }
    }
  }
};
</script>

<style>
.container {
  margin: 20px;
}
</style>
